/**
 * Opt-in samples for COMPILE_BENCH Playwright. Production paths no-op unless
 * the benchmark page installed `window.__compileBench`.
 */
export function recordCompileBenchRecomposition(kind, durationMs, extra) {
    if (typeof window === 'undefined') {
        return;
    }
    const bench = window.__compileBench;
    if (!bench?.recompositionSamples) {
        return;
    }
    bench.recompositionSamples.push({
        lane: bench.lane || 'idle',
        kind,
        ms: durationMs,
        ...(extra?.glyphCount !== undefined
            ? { glyphCount: extra.glyphCount }
            : {})
    });
}
